import { useState, useEffect } from "react";
import { FilterCondition } from "../../types/queueTypes";


type UseDataAPIProps = {
    entityName: string;
    first: number;
    select?: string[];
    filter?: FilterCondition[];
};

// This hook is using Data Builder API, and the config file is at root/swa-db-connections/staticwebapp.database.config.json
const useDataAPI = ({ entityName, first, select, filter }: UseDataAPIProps) => {
    const [entityItems, setEntityItems] = useState([]);
    const [loading, setLoading] = useState(true);

    first = first == null ? 100 : first;
    
    useEffect(() => {
        (async function () {
            const selectParam = select ? `&$select=${select.join(',')}` : '';
            
            let filterParam = '';
            if (filter && filter.length > 0) {
                const filterConditions = filter.map(condition => {
                    const { field, value } = condition;
                    const encodedField = encodeURIComponent(field);
                    const encodedValue = typeof value === 'string' 
                        ? `'${encodeURIComponent(value)}'` 
                        : encodeURIComponent(value.toString());
                    
                    return `${encodedField} eq ${encodedValue}`;
                });
                
                filterParam = `&$filter=${encodeURIComponent(filterConditions.join(' and '))}`;
            }
            
            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-MS-API-ROLE": "admin",
                },
            };
            
            const result = await (
                await fetch(
                    `data-api/rest/${entityName}?$first=${first}${selectParam}${filterParam}`,
                    requestOptions
                )
            ).json();
            setEntityItems(result.value);
            setLoading(false);
        })();
    }, [entityName, first, select, filter]);

    return {
        entityItems: entityItems,
        loading: loading,
    };
};

export default useDataAPI;
